import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMembersEmployeeSurveySubmissionRepliesShowResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiMembersEmployeeSurveySubmissionRepliesShowResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeeSurveySubmissionRepliesShowResponseType>(
      `/api/members/employee_survey_submission_replies/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeeSurveySubmissionRepliesShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersEmployeeSurveySubmissionRepliesShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersEmployeeSurveySubmissionRepliesShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
